export default {
  url: /^(app\/|http:\/\/|https:\/\/)/,
};
